export default __webpack_public_path__ + "static/media/beam-logo.2759c43b.svg";